import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import { TopOffendersAggCityReportRequest } from '../requests/TopOffendersAggCityRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const TopOffendersAggCityExport = (values, userId) => async (dispatch) => {
	await TopOffendersAggCityReportRequest(values, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
